import React from "react";
import ProjectCard from "./ProjectCard";

const ProjectGrid = ({ projects, onOpen }) => (
  <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {projects.map((p) => (
      <ProjectCard key={p.id} project={p} onOpen={onOpen} />
    ))}
  </div>
);

export default ProjectGrid;
